import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const ContainerButton = styled(Col)`
  @media screen and (max-width: 525px) {
    margin-top: 1rem;
  }
`;
